import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import useApprovalNotifier from "@/hooks/useApprovalNotifier";
import useChatNotifier from "@/hooks/useChatNotifier";

const ProtectedAdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const isAdmin = !!user && user?.role === "admin";
  // Global admin notifier — polls pending counts every 30 s and fires a
  // chime + browser notification when new work arrives, so admins don't
  // have to keep the Inbox tab open. Mounted here so it runs on every
  // admin route without duplicating instances.
  useApprovalNotifier(isAdmin);
  // Sibling notifier for Sable chat sessions — polls every 15 s and fires
  // a distinct three-tone chime the moment a new visitor starts chatting.
  useChatNotifier(isAdmin);

  if (loading) {
    return (
      <div
        className="min-h-screen bg-[#05050a] flex items-center justify-center"
        data-testid="admin-loading"
      >
        <Loader2 className="text-[#00f0ff] animate-spin" size={28} />
      </div>
    );
  }
  if (!user || user.role !== "admin") {
    return (
      <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
    );
  }
  return children;
};

export default ProtectedAdminRoute;
